import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: any[]) {
    return twMerge(clsx(inputs));
}

export const isEmpty = (data: any) => {
    return ['', null, 'null', undefined].includes(data);
};

export const isProduction = () => {
    return !isEmpty(process.env.NEXT_PUBLIC_IS_PRODUCTION) && process.env.NEXT_PUBLIC_IS_PRODUCTION === 'true';
};

export const validateEmail = (email: any) => {
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        return true;
    } else {
        return false;
    }
};

export const getLocalItem = (item: string) => {
    return localStorage.getItem(item) || '';
};

export const addIntoLocalStorage = (item: string, value: string) => {
    localStorage.setItem(item, value);
};

export const getFullUrl = (route: string) => {
    return route === '/' ? `${process.env.NEXT_PUBLIC_FRONT_URL}` : `${process.env.NEXT_PUBLIC_FRONT_URL}/${route}`;
};

export const isBrowser = () => typeof window !== 'undefined'; //The approach recommended by Next.js

export const scrollToTop = () => {
    if (!isBrowser()) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const formDataConverter = (list: any, removeKeyList?: any) => {
    let formData = new FormData();

    Object.entries(list).map((object: any) => {
        if (!removeKeyList.includes(object[0])) {
            return formData.append(object[0], object[1]);
        }
    });

    return formData;
};

// Dark mode paths for specific pages
export const darkModePaths = [
    '/ai-ml-development-services',
    '/vision-ai-multimodal-ai',
    '/ai-strategy-consulting',
    '/ai-agents-and-intelligent-automation',
    '/generative-ai-llm-development',
    '/pmigjc-anantam-2025',
    '/ai-security-and-governance',
    '/machine-learning-mlops-services',
    '/ai-platform-integration',
    '/data-engineering-foundations',
    '/',
];

export const allowDarkMode = (pathname: any) => {
    return darkModePaths.includes(pathname);
};
